export function formatBytes(bytes, decimals = 2) {
  if (bytes === 0) return "0 Bytes";

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
}

export function setCurrentLanguage(lang) {
  localStorage.setItem("CURRENT_LANGUAGE", lang);
}

export function getCurrentLanguage() {
  return localStorage.getItem("CURRENT_LANGUAGE") || "en";
}

export default { formatBytes, setCurrentLanguage, getCurrentLanguage };
